module.exports = __webpack_public_path__ + "static/img/应用场景6-历史监控回顾.8ac0741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-2/应用场景6-历史监控回顾.png
// module id = NtoV
// module chunks = 0